import { render } from "./KnotBoardDemo.vue?vue&type=template&id=490fe0f1&scoped=true"
import script from "./KnotBoardDemo.vue?vue&type=script&lang=js"
export * from "./KnotBoardDemo.vue?vue&type=script&lang=js"

import "./KnotBoardDemo.vue?vue&type=style&index=0&id=490fe0f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490fe0f1"]])

export default __exports__